import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { AdTargetAttributeTypes, AdTargetAttributeTypesVariables } from './__generated__/AdTargetAttributeTypes';

export const AD_TARGET_ATTRIBUTE_TYPES_QUERY = gql`
  query AdTargetAttributeTypes($path: AdTargetAttributeSearchPathsEnum!, $query: String!) {
    adTargetAttributeTypes(path: $path, query: $query)
  }
`;

export const useAdTargetAttributeTypesQuery = () => {
  return useLazyQuery<AdTargetAttributeTypes, AdTargetAttributeTypesVariables>(AD_TARGET_ATTRIBUTE_TYPES_QUERY, {
    client: kmsClient
  });
};
